import React from 'react';

import StatusPill from '../../shared/status_pill';
import { fmt_count } from '../../format';
import { BUCKET_LABELS, bucket_count } from './adapters';
import { RUN_BUCKET_TABS, RUN_ITEMS_PAGE } from './params';

/*
 * PROD-7828 D110 — a run's teachers, one bucket at a time ("Needs attention" first), paged by the
 * server. Each row renders the per-teacher close/reopen result the dialogs always showed (blocker
 * lines with how_to_fix, grant mismatch); a blocked teacher links to its tier's issues (CD-104).
 * Props-only.
 */
const RunItems = ({ run, bucket, offset, loading, on_bucket, on_page, on_view_issues }) => {
  const total = run.items_total;
  const first = total ? offset + 1 : 0;
  const last = Math.min(offset + run.items.length, total);
  return (
    <div>
      <div className="tp-seg" role="group" aria-label="Show teachers">
        {RUN_BUCKET_TABS.map((b) => (
          <button
            key={b}
            type="button"
            className={bucket === b ? 'on' : ''}
            aria-pressed={bucket === b}
            onClick={() => (bucket === b ? undefined : on_bucket(b))}
          >
            {BUCKET_LABELS[b]} ({fmt_count(bucket_count(run.counts, b))})
          </button>
        ))}
      </div>
      <div className="tp-na-scroll" aria-busy={loading ? 'true' : undefined}>
        {run.items.map((it) => (
          <div key={it.key} className="tp-na-row">
            <div>
              <StatusPill tone={it.status_tone}>{it.status_label}</StatusPill>{' '}
              <b>{it.teacher_name}</b>
              {it.facts_text ? ` · ${it.facts_text}` : ''}
            </div>
            {it.lines.map((line, i) => (
              // Two blockers can share a sentence; the position keeps the keys apart.
              // eslint-disable-next-line react/no-array-index-key
              <div key={`${it.key}-${i}`} className="tp-na-blocker">
                {line}
              </div>
            ))}
            {it.issues_tier ? (
              <button
                type="button"
                className="tp-link"
                onClick={() => on_view_issues(it.issues_tier, it.teacher_uuid)}
              >
                View {it.teacher_name}&apos;s issues
              </button>
            ) : null}
          </div>
        ))}
        {run.items.length ? null : <div className="tp-empty">No teachers in this list yet.</div>}
      </div>
      <div className="tp-frow">
        <span className="tp-card-hd-sub">
          {total
            ? `Showing ${fmt_count(first)}–${fmt_count(last)} of ${fmt_count(total)}`
            : 'Showing 0'}
        </span>
        <div className="tp-frow-right">
          <button
            type="button"
            className="tp-btn-ghost"
            onClick={
              offset > 0 && !loading
                ? () => on_page(Math.max(offset - RUN_ITEMS_PAGE, 0))
                : undefined
            }
            aria-disabled={offset > 0 && !loading ? undefined : 'true'}
          >
            Previous
          </button>
          <button
            type="button"
            className="tp-btn-ghost"
            onClick={last < total && !loading ? () => on_page(offset + RUN_ITEMS_PAGE) : undefined}
            aria-disabled={last < total && !loading ? undefined : 'true'}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default RunItems;
